function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.415 8.506L2.089.204a.698.698 0 00-.985.988L8.934 9l-7.83 7.808a.698.698 0 10.985.988l8.326-8.302a.697.697 0 000-.988z",
  fill: "#fff"
});

function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    fill: "none"
  }, props), _ref);
}

export default SvgIconArrowRight;